<script>
import CustomerRatingItem from '../CustomerRatingItem/index.vue'
import { getCompanyEvaluateList } from '~/api/company.api'
import { getProjectEvaluateList } from '~/api/project.api'

export default {
  components: {
    CustomerRatingItem
  },
  props: {
    width: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      EvaluateList: [],
      pageNo: 1,
      pageSize: 3,
      isLastPage: false,
      isLoading: false
    }
  },
  created() {
    this.getEvaluateList()
  },
  methods: {
    getEvaluateList
  }
}

async function getEvaluateList() {
  if (this.isLoading || this.isLastPage) return
  this.isLoading = true

  let res = ''
  if (this.$route.params.projectId) {
    res = await getProjectEvaluateList({
      pageNo: this.pageNo,
      pageSize: this.pageSize,
      projectId: this.$route.params.projectId
    })
  } else {
    res = await getCompanyEvaluateList({
      pageNo: this.pageNo,
      pageSize: this.pageSize,
      companyId: this.$route.params.companyId
    })
  }
  if (res.length > 0) {
    this.EvaluateList = this.EvaluateList.concat(res)
  }
  this.isLoading = false
  if (res.length < this.pageSize) {
    this.isLastPage = true
  }
  this.pageNo++
}
</script>
<template>
  <ul class="project_rating_list4_small_screen_container">
    <li
      v-for="(evaluate, index) in EvaluateList"
      :key="index"
      class="project_rating_list_item_li_4_small_screen_container"
    >
      <CustomerRatingItem :evaluate="evaluate" :width="width" />
    </li>
    <span v-if="!isLastPage" @click="getEvaluateList" class="more_ratings"
      >查看更多业主评价</span
    >
  </ul>
</template>
<style lang="scss">
@media screen and (max-width: 940px) {
  .project_rating_list4_small_screen_container {
    padding: 0;
    margin: 0;
    //padding-right: 15px;
    * {
      margin: 0;
      padding: 0;
    }

    .project_rating_list_item_li_4_small_screen_container {
      display: flex;
      position: relative;
      margin-top: 15px;
      // border: 1px solid red;
    }

    .more_ratings {
      display: block;
      text-align: center;
      padding: 15px 0;
      border: 1px solid rgba(239, 241, 242, 1);
      font-size: 14px;
      color: rgba(68, 68, 68, 1);
      line-height: 14px;
      width: 100%;
    }
  }
}
</style>
